var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.01 7.99L13.01 4.99M1.5 19.5C2.33 20.33 3.67 20.33 4.5 19.5L17.5 6.5C18.33 5.67 18.33 4.33 17.5 3.5C16.67 2.67 15.33 2.67 14.5 3.5L1.5 16.5C0.670002 17.33 0.670002 18.67 1.5 19.5ZM6.5 1.44L8 1L7.56 2.5L8 4L6.5 3.56L5 4L5.44 2.5L5 1L6.5 1.44ZM2.5 7.44L4 7L3.56 8.5L4 10L2.5 9.56L1 10L1.44 8.5L1 7L2.5 7.44ZM17.5 12.44L19 12L18.56 13.5L19 15L17.5 14.56L16 15L16.44 13.5L16 12L17.5 12.44Z",
    stroke: "#2C3439",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAi);
export default __webpack_public_path__ + "static/media/pencil-ai.c0826d4f5e196012a1694934abffbdc0.svg";
export { ForwardRef as ReactComponent };